import { memo, useContext, useEffect } from 'react';
import { datadogRum } from '@sunbit-dev/common/services/datadog';
import { logsService } from '~/services/logsService';
import { ABTestsContext } from '~/contexts/abTests/abTestsContext';
import { AppContext } from '~/contexts/appContext';
import { PurchaseContext } from '~/contexts/purchaseContext';
import { UserContext } from '~/contexts/userContext';

export const LogsTracking = memo(() => {
  const abTestsContext = useContext(ABTestsContext);
  const appContext = useContext(AppContext);
  const purchaseContext = useContext(PurchaseContext);
  const userContext = useContext(UserContext);

  useEffect(() => {
    const { isPs1Associated, retailer } = appContext;
    const { user } = userContext || {};
    const { id: customerId } = user || {};

    const {
      allianceGeneralInfo,
      amountRequested,
      merchantId,
      merchantName,
      merchantType,
      merchantVertical,
      merchantAddress,
      merchantOriginatorActiveStates,
      onlineLogoUrl,
      subUrlName,
      origin,
      onlinePurchaseSupportedTypes,
      chainFeatures,
    } = retailer;

    const { amount, maxAmountApproved, paymentPlans, selectedPlanIndex } = purchaseContext;

    const data = {
      amountRequested,
      merchantId,
      merchantName,
      merchantType,
      merchantVertical,
      merchantAddress,
      merchantOriginatorActiveStates,
      onlineLogoUrl,
      subUrlName,
      origin,
      onlinePurchaseSupportedTypes,
      chainFeatures,
      amount,
      maxAmountApproved,
      paymentPlans,
      selectedPlanIndex,
      isPs1Associated,
      ...allianceGeneralInfo,
      ...abTestsContext.properties.getAllFlat(),
      ...(customerId && { customerId }),
    };

    logsService.setInfo(data);
    datadogRum.addRumGlobalContext('app', data);
  }, [abTestsContext, purchaseContext, appContext, userContext]);

  return null;
});
